import { apiFetch } from "@/api/client";
import type {
  Store,
  CreateStorePayload,
  UpdateStorePayload,
  PageResponse,
  StoreAuditEntry,
  StorePageQuery,
} from "./types";

const STORE_ENDPOINTS = {
  list: "/stores",
  detail: (id: string) => `/stores/${id}`,
};

export function listStores(
  limit = 50,
  offset = 0,
): Promise<PageResponse<Store>> {
  return apiFetch(`${STORE_ENDPOINTS.list}?limit=${limit}&offset=${offset}`);
}

export function listStorePage(
  query: StorePageQuery,
  signal?: AbortSignal,
): Promise<PageResponse<Store>> {
  const params = new URLSearchParams({
    limit: String(query.limit),
    offset: String(query.offset),
  });
  const search = query.search.trim();
  if (search) params.set("search", search);

  return apiFetch(`${STORE_ENDPOINTS.list}?${params}`, { signal });
}

export function getStore(id: string): Promise<Store> {
  return apiFetch(STORE_ENDPOINTS.detail(id));
}

export function createStore(payload: CreateStorePayload): Promise<Store> {
  return apiFetch(STORE_ENDPOINTS.list, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateStore(
  id: string,
  payload: UpdateStorePayload,
): Promise<Store> {
  return apiFetch(STORE_ENDPOINTS.detail(id), {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function deleteStore(id: string): Promise<void> {
  return apiFetch(STORE_ENDPOINTS.detail(id), { method: "DELETE" });
}

export function getStoreAuditLog(
  id: string,
  limit = 50,
  offset = 0,
): Promise<PageResponse<StoreAuditEntry>> {
  return apiFetch(
    `${STORE_ENDPOINTS.detail(id)}/audit?limit=${limit}&offset=${offset}`,
  );
}
